export default __webpack_public_path__ + "static/AvenirLTStd-MediumOblique-4dc4b9c47bff20ca6054dc07563afac2.woff2";